import isNil from 'lodash/isNil';

export type RevisionPairs = [number | null | undefined, number | null | undefined][];
export const isRevised = (valuePairs: RevisionPairs) => {
  const hasNilValues = valuePairs.some(([initial, revised]) => isNil(initial) || isNil(revised));

  if (hasNilValues) {
    return false;
  }

  return valuePairs.some(([initial, revised]) => initial !== revised);
};
